import { FLAG_GRADIENT_DEFAULT_ANGLE, FLAGS_COLOR_CODES } from '~constants'

/**
 * Maps dropdown / free-text input to the flag.color shape expected by the API.
 * Preset hex values use catalog names; any other non-empty string becomes a custom color.
 */
export const resolveFlagColorFromInput = input => {
  if (input == null) {
    return null
  }
  const trimmed = String(input).trim()
  if (!trimmed) {
    return null
  }
  const normalizedHex = trimmed.startsWith('#') ? trimmed : `#${trimmed}`
  const preset = FLAGS_COLOR_CODES.find(
    f =>
      f.value === trimmed ||
      f.value.toLowerCase() === trimmed.toLowerCase() ||
      f.value.toLowerCase() === normalizedHex.toLowerCase()
  )
  if (preset) {
    return { ...preset }
  }
  const value = trimmed.startsWith('#') ? trimmed : `#${trimmed}`
  return { name: trimmed, value }
}

/**
 * Builds a CSS `linear-gradient(...)` string from a flag.background_gradient object.
 * Returns null when the gradient is missing or has fewer than two valid stops.
 */
export const getGradientCss = gradient => {
  if (!gradient || !Array.isArray(gradient.stops)) {
    return null
  }
  const stops = gradient.stops.filter(s => s && typeof s.value === 'string' && s.value.trim())
  if (stops.length < 2) {
    return null
  }
  const angle = Number.isFinite(gradient.angle) ? gradient.angle : FLAG_GRADIENT_DEFAULT_ANGLE
  return `linear-gradient(${angle}deg, ${stops.map(s => s.value).join(', ')})`
}
